import { selectIsLoggedIn, selectUser } from 'containers/Login/loginSlice'
import { selectChatUnreadNotifications } from 'containers/Chats/chatSlice'
import useTranslation from 'hooks/useTranslation'
import Message from 'components/icons/Message'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import useLogout from 'hooks/useLogout'

const MenuItem = ({ icon, text, action, isMuted = false }) => {
  return <div
    className='nav__item'
    style={isMuted ? { opacity: 0.5 } : undefined}
    onClick={action}>
    <div className='item__svg'>
      {typeof icon === 'string'
        ? <i className={`icon icon--${icon} s24`} />
        : icon}
    </div>
    <span>{text}</span>
  </div>
}

const Menu = ({ isDesktop = false }) => {
  const unreadMessages = useSelector(selectChatUnreadNotifications)
  const isLoggedIn = useSelector(selectIsLoggedIn)
  const { name } = useSelector(selectUser)

  const logout = useLogout()
  const { push } = useHistory()
  const { t } = useTranslation('menu')

  return (
    <aside className={`app__menu ${isDesktop ? '--desktop' : ''}`}>
      {!isDesktop && <div className='menu__logo center'>
        {process.env.REACT_APP_TYPE === 'mm'
          ? <>
            <i className='icon icon--logo' />
            <span className='--secFont'>Magazynomaty</span>
          </>
          : <i className={`icon icon--${process.env.REACT_APP_TYPE}-full-logo-v`} />}
      </div>}

      <div className='menu__nav'>
        {!isDesktop && <p className='menu__greeting'>
          <span>{t('welcomeToTheBackstage')}{isLoggedIn && name ? `, ${name}` : ''}!</span>
        </p>}

        <MenuItem
          icon='plus'
          text={t('order')}
          action={() => {
            push('/home')
          }} />

        <hr />

        <MenuItem
          icon='dashboard'
          text={t('dashboard')}
          isMuted={!isLoggedIn}
          action={() => {
            push(isLoggedIn ? '/dashboard' : '/login')
          }} />

        <MenuItem
          icon='mag-details'
          text={t('warehouses')}
          isMuted={!isLoggedIn}
          action={() => {
            push(isLoggedIn ? '/warehouses' : '/login')
          }} />

        <MenuItem
          icon='user'
          text={t('account')}
          isMuted={!isLoggedIn}
          action={() => {
            push(isLoggedIn ? '/account' : '/login')
          }} />

        <hr />

        <MenuItem
          icon={<Message isNewMessage={!!unreadMessages} />}
          text={t('messages')}
          action={() => {
            push('/chat')
          }} />

        <MenuItem
          icon='settings'
          text={t('settings')}
          action={() => {
            push('/account/settings')
          }} />

        <MenuItem
          icon='help'
          text={t('help')}
          action={() => {
            push('/help')
          }} />

        {isDesktop
          ? <div className='space' />
          : <hr />}

        {isLoggedIn
          ? <MenuItem
            icon='logout'
            text={t('logOut')}
            action={logout} />
          : <MenuItem
            icon='login'
            text={t('logIn')}
            action={() => {
              push('/login')
            }} />}

      </div>
    </aside>
  )
}

export default Menu